import { useState } from 'react';
import { SINGLE_LINE_ROW_HEIGHT, TWO_LINE_ROW_HEIGHT } from './searchableSelectStyles';
import { SelectOption } from './searchableSelectTypes';

const resolveRowHeight = <V extends string | number>(options: SelectOption<V>[]) => {
  if (options.length === 0) return undefined;
  return options.some((option) => option.description)
    ? TWO_LINE_ROW_HEIGHT
    : SINGLE_LINE_ROW_HEIGHT;
};

/** An empty result has no rows to read a height from, so the last known one is kept and the panel doesn't resize. */
export const useRowHeight = <V extends string | number>(options: SelectOption<V>[]) => {
  const currentRowHeight = resolveRowHeight(options);
  const [lastRowHeight, setLastRowHeight] = useState(currentRowHeight ?? SINGLE_LINE_ROW_HEIGHT);

  if (currentRowHeight !== undefined && currentRowHeight !== lastRowHeight) {
    setLastRowHeight(currentRowHeight);
  }

  return currentRowHeight ?? lastRowHeight;
};
